export default "__VITE_ASSET__CHuuUFtg__"